import React from 'react';

  // Feature1 skeleton that matches the exact layout and proportions
  const Feature1Skeleton = () => (
    <div className="flex flex-col xl:flex-row items-center justify-center pb-14 pt-16 px-4 lg:pb-[120px]">
      {/* Image placeholder matching the exact size of ImgSectionPlanesServicio */}
      <div className="max-w-[358px] lg:max-w-[486px] h-[240px] lg:h-[325px] bg-gray-200 rounded-lg animate-pulse"></div>
      
      {/* Content section */}
      <div className="lg:ml-[126px] lg:max-w-[486px] mt-8 w-full">
        {/* Title placeholder */}
        <div className="h-8 lg:h-12 bg-gray-200 rounded-md w-[85%] animate-pulse"></div>
        
        {/* List items with matching spacing */}
        <ul className="max-w-[358px] flex items-start flex-col m-0 p-0 space-y-3 lg:space-y-6 mt-4 lg:mt-10">
          {/* Item 1 */}
          <li className="flex items-center justify-start space-x-4 w-full">
            <div className="size-6 lg:size-10 rounded-full bg-blue-200 animate-pulse"></div>
            <div className="h-6 bg-gray-200 rounded-md w-[80%] animate-pulse"></div>
          </li>
          
          {/* Item 2 */}
          <li className="flex items-center justify-start space-x-4 w-full">
            <div className="size-6 lg:size-10 rounded-full bg-blue-200 animate-pulse"></div>
            <div className="h-6 bg-gray-200 rounded-md w-[85%] animate-pulse"></div>
          </li>
          
          {/* Item 3 */}
          <li className="flex items-center justify-start space-x-4 w-full">
            <div className="size-6 lg:size-10 rounded-full bg-blue-200 animate-pulse"></div>
            <div className="h-6 bg-gray-200 rounded-md w-[75%] animate-pulse"></div>
          </li>
        </ul>
      </div>
    </div>
  );


export default Feature1Skeleton;